import { render, staticRenderFns } from "./TeledeclarationBanner.vue?vue&type=template&id=b26a73da&scoped=true&"
import script from "./TeledeclarationBanner.vue?vue&type=script&lang=js&"
export * from "./TeledeclarationBanner.vue?vue&type=script&lang=js&"
import style0 from "./TeledeclarationBanner.vue?vue&type=style&index=0&id=b26a73da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26a73da",
  null
  
)

export default component.exports